import React from "react";
import VisualTimerPie from "./VisualTimerPie";
import { formatDisplayTime, getTimerDisplayLabel } from "./timeHelpers";

export default function TimerDisplay({
  mode,
  editing,
  timerSeconds,
  handleTimerClick,
  inputValue,
  handleInputChange,
  inputRef,
  handleInputBlurOrEnter,
  handleInputKeyDown,
  theme,
  baseSeconds,
  displayMode,
  currentPhase,
  selectedPreset,
  running,
  timerPairs,
  currentStep,
  onTimeChange,
}) {
  // --- wasFocused state for clearing input on first focus ---
  const [wasFocused, setWasFocused] = React.useState(false);

  // --- Display Label Logic ---
  const displayLabel = getTimerDisplayLabel({
    mode,
    running,
    currentPhase,
    selectedPreset,
    timerPairs,
    currentStep,
  });

  // Reset wasFocused when leaving edit mode
  React.useEffect(() => {
    if (!editing) setWasFocused(false);
  }, [editing]);

  return (
    <div className="flex flex-col items-center justify-center">
      {/* Label above timer */}
      <span
        className="uppercase tracking-wide text-lg mb-4"
        style={{
          color: theme.colors.text,
          fontFamily: theme.fontFamily,
        }}
      >
        {displayLabel}
      </span>

      {/* TEXT DISPLAY */}
      {!editing && displayMode === "text" && (
        <span
          className={`text-7xl font-bold mb-4 select-none drop-shadow-xl transition ${
            mode !== "stopwatch" ? "cursor-pointer hover:opacity-70" : "cursor-default"
          }`}
          onClick={mode !== "stopwatch" ? handleTimerClick : undefined}
          title={mode !== "stopwatch" ? "Click to edit" : undefined}
          style={{ color: theme.colors.timerText }}
        >
          {formatDisplayTime(timerSeconds)}
        </span>
      )}

      {/* PIE DISPLAY */}
      {!editing && displayMode === "pie" && (
        <div className="mb-12">
          <VisualTimerPie
            timerSeconds={timerSeconds}
            baseSeconds={baseSeconds}
            theme={theme}
            onTimeChange={onTimeChange}
            running={running}
          />
        </div>
      )}

      {/* INPUT FIELD (not for stopwatch mode) */}
      {editing && mode !== "stopwatch" && !running && (
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlurOrEnter}
          onKeyDown={handleInputKeyDown}
          className="text-7xl font-bold mb-4 px-2 py-1 rounded-lg text-center w-[600px] focus:ring-0 focus:outline-none border-none"
          maxLength={8}
          autoFocus
          style={{
            backgroundColor: theme.colors.background,
            color: theme.colors.timerText,
          }}
          onFocus={e => {
            if (!wasFocused) {
              setWasFocused(true);
              if (inputValue !== "") {
                handleInputChange({ target: { value: "" } });
              }
            }
          }}
        />
      )}
    </div>
  );
}
